import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { mockApiServices } from 'app/mock-api';
import { LayoutModule } from 'app/layout/layout.module';
import { environment } from '../environments/environment';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { MaintenanceModalComponent } from 'app/core/maintenance/maintenance-modal.component';
import {
    DateAdapter,
    MAT_DATE_FORMATS,
    MAT_DATE_LOCALE,
    MatNativeDateModule,
    MatOptionModule
} from "@angular/material/core";
import { MomentUtcDateAdapter } from './moment-utc-date-adapter';
import {MatDatepickerModule} from "@angular/material/datepicker";
import {CurrencyMaskModule} from "ng2-currency-mask";
import {NgxMaskModule} from 'ngx-mask';
import {FormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatSelectModule} from "@angular/material/select";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatChipsModule} from "@angular/material/chips";
import {MatRadioModule} from "@angular/material/radio";
import {NgApexchartsModule} from "ng-apexcharts";
import {MatTooltipModule} from "@angular/material/tooltip";
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';


registerLocaleData(ptBr);

const routerConfig: ExtraOptions = {
    preloadingStrategy       : PreloadAllModules,
    scrollPositionRestoration: 'enabled'
};

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),
        NgxMaskModule.forRoot(),
        MatNativeDateModule,
        MatDatepickerModule,
        CurrencyMaskModule,

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        // Mock API only in development
        ...(environment.production ? [] : [FuseMockApiModule.forRoot(mockApiServices)]),

        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule,

        // Maintenance modal
        MaintenanceModalComponent,

        FormsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatOptionModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatAutocompleteModule,
        MatChipsModule,
        MatRadioModule,
        NgApexchartsModule,
        MatTooltipModule
    ],
    bootstrap: [
        AppComponent
    ],
    exports: [

    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }
    ]
})
export class AppModule
{
}
